<template>
  <div class="absolute top-20 left-20 z-15">
    <div class="relative w-[403px] ">
      <img :class="{
        'right-[-11px]': direction === 'right',
        'left-[-7px] scale-x-[-1]': direction === 'left',
        'bottom-[-170px] left-[40px] rotate-90': direction === 'bottom'
      }"
           alt="polygon"
           class="absolute h-[36px] w-[20px] top-[11px] m-auto z-10"
           src="@/assets/icons/global/onboarding-polygon.svg">
      <div class="bg-white h-[170px] w-[392px] py-5 shadow-lg rounded overflow-hidden relative">
       <span
           class="absolute left-1 top-1 material-symbols-rounded z-50 text-base cursor-pointer text-black bg-white p-1 rounded-full"
           @click.stop="close">close</span>
        <img :alt="tooltip?.title" :class="tooltip?.style" :src='`${tooltip?.image}`'
             class="h-full object-contain top-0 absolute z-0">
        <div class="flex flex-col items-start justify-center h-full max-w-[270px] p-4">
          <span class="text-primary-300 font-bold text-base">{{ tooltip?.title }}</span>
          <span class="text-grays-900 font-regular text-sm">{{ tooltip?.content }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UpdateScaleImage from '@/assets/tooltip/UpdateScale.png';
import RemindersImage from '@/assets/tooltip/Reminders.png';
import SalesBoardImage from '@/assets/tooltip/SalesBoard.png';
import MissingProductsImage from '@/assets/tooltip/MissingProducts.png';
import GreenTooltipImage from '@/assets/tooltip/GreenTooltip.png';
import CartImage from '@/assets/tooltip/Cart.png';
import ParentProductImage from '@/assets/tooltip/ParentProduct.png';

export default {
  name: "TooltipContainer",
  data() {
    return {
      tooltip: {},
      configs: {
        UpdateScale: {
          title: 'עדכון משקל',
          content: 'עדכון משקל עושים בקלות עם הקלדת הבר קוד במערכת. הזיכוי או החיוב מתעדכן אוטומטי ומחכה לכם למימוש בקניה הבאה.',
          image: UpdateScaleImage,
          style: 'left-[-80px]'
        },
        Reminders: {
          title: 'אפשר להזכיר לכם?',
          content: 'תכנסו כדי לבחור איך אתם רוצים לקבל את התזכורות שלכם, במייל או בטלפון.',
          image: RemindersImage,
          style: 'left-[-66px]'
        },
        SalesBoard: {
          title: 'לוח מכירות',
          content: 'מעכשיו הכל נמצא בלוח המכירות. אפשר לראות מכירות פתוחות והזמנות שמחכות לכם לאיסוף.',
          image: SalesBoardImage,
          style: 'left-[-36px]'
        },
        MissingProducts: {
          title: 'נוח יותר!',
          content: 'אנחנו דואגים ומשתדלים לעדכן אתכם על חוסרים עוד לפני תאריך האיסוף.',
          image: MissingProductsImage,
          style: 'left-[-50px]'
        },
        GreenTooltip: {
          title: 'טוב לדעת!',
          content: 'חיפשתם תשובה על זה? כל התשובות על שאלות שהיו לכם ועוד דברים מעניינים תוכלו לראות בלחיצה על כפתור \'טוב לדעת\'. נסו את זה!',
          image: GreenTooltipImage,
          style: 'left-[-50px]'
        },
        Cart: {
          title: 'סל משפחתי',
          content: 'כל מה שהזמנתם, אתם רואים מיד על המסך בצד. ככה תעקבו תוך כדי ההזמנה על המוצרים שכבר קניתם.',
          image: CartImage,
          style: 'left-[-10px]'
        },
        ParentProduct: {
          title: 'מתאימים במקסימום!',
          content: ' מהיום אתם נכנסים ישר למוצר הרלוונטי ושם בוחרים את המידה והדגם שמתאים לכם.',
          image: ParentProductImage,
          style: 'left-[5px]'
        },
      }
    }
  },
  props: {
    type: {
      type: String,
      default: 'Reminders',
    },
    direction: {
      type: String,
      default: 'right',
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  },
  watch: {
    type() {
      this.tooltip = this.configs[this.type];
    }
  },
  mounted() {
    this.tooltip = this.configs[this.type];
  }
}
</script>

<style scoped>
</style>
